import React from 'react';
import GlobalConfiguartionBasicInfoComponent from './global-configuration-basic-info.component';
import GlobalConfiguartionServiceRequestComponent from './global-configuration-ServiceRequest.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const GlobalComponent = ({
  periods,
  handleInnerFormChange,
  chosenGlobalConfigurations,
  back,
  handleFormSubmit,
  chosenServiceRequest
}: any) => {

  const tabItems=[
    {
        id:1,
        title:'Domain Configuration Information',
        component:<GlobalConfiguartionBasicInfoComponent
        chosenGlobalConfigurations={chosenGlobalConfigurations} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    },
    {
      id:2,
      title:'Service request Configuration Information',
      component:<GlobalConfiguartionServiceRequestComponent
      periods={periods}
      chosenServiceRequest={chosenServiceRequest} 
      handleInnerFormChange={handleInnerFormChange}
  />,
  isVisible:true,
  }
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
};
export default GlobalComponent;
